/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch, useSelector } from 'react-redux';
import { trackPublish, showPublishErrors
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/publishActions';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error Untyped module
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getIsStagingV2 } from 'ContentEditorUI/redux/selectors/authSelectors';
import { useCallback, useContext, useMemo } from 'react';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { fetchContent, fetchHardSavedContent
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/contentActions';
import { getAbsoluteUrl, getIsBlogListingPage, getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getShouldOpenPostPublishCustomDomainSetupModal, getShouldOpenPostPublishContentRemixModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { markActionComplete } from 'user-context/onboarding';
// @ts-expect-error Untyped module
import { PAGES_API_BASE_URL } from 'page-editor-ui/Constants';
// @ts-expect-error Untyped module
import { showThrottledPostPagePublishCsatSurvey } from 'ContentEditorUI/lib/csatSurvey';
import { getIsAdvancedPageTemplateOrHasAdvancedFeaturesAccess } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { getContentModelDynamicPageSourceValue, getDynamicPageSourceType, getIsPersonalizedVariant } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { displayPublishSuccessAlert } from 'ContentEditorUI/utils/displayPublishSuccessAlert';
import { getPublishedOrStagingUrl, getStagedPageDomainName
// @ts-expect-error non-ts module import
} from 'page-editor-ui/redux/selectors/urlSelectors';
import { togglePostPublishDomainSetupModal, openModal
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/appActions';
import { PublishTypes } from 'ContentEditorUI/constants/PublishTypes';
import { getOnboardingToursTask, isFromPaymentsGuide } from 'payments-post-enroll-local-storage-lib/data/onboardingTours';
import { getActiveDomainIsConnected, getActiveDomainIsInternal } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
import { getHasAnyLayoutSections } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
// @ts-expect-error Untyped module
import { save as saveAction } from '../redux/actions/pageSaveActions';
import { useAiLpThankYouPageReminder } from './useAiLpThankYouPageReminder';
import Raven from 'raven-js';
import { getHasPersonalizationAccess } from '../redux/selectors/authSelectors';
import { getThemePath } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { useShouldDisplayPostPublishCustomerAgentModal } from 'ContentEditorUI/hooks/useShouldDisplayPostPublishCustomerAgentModal';
import { useEmbeddedEditorContext } from 'campaigns-lib/embedded/EmbeddedEditorContext';
import { usePersonalizedPageUrl } from './usePersonalizedPageUrl';
import useContentCrmObject from 'ContentEditorUI/components/publishing/hooks/useContentCrmObject';
import { buildSandboxUrl } from '../utils/urlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const showPagesCsatSurvey = (notStarterCustomerish, publishType) => {
  const isPublishingOrScheduling = publishType === PublishTypes.publish || publishType === PublishTypes.schedule;

  // Only show the survey to pages that were just published/scheduled (not updated)
  // ... and _not_ to customers in the LP starter beta (using a page from a starter template)
  if (isPublishingOrScheduling && notStarterCustomerish) {
    showThrottledPostPagePublishCsatSurvey();
  }
};

// Configured to only work with unified publish button setup
const usePublishLifecycleHandlers = (setShowUseCaseTourCompleteModal, setShowNextActionModal) => {
  const {
    handleAppOnPublish,
    isInsideMarketingStudio
  } = useEmbeddedEditorContext();
  const {
    tour
  } = useContext(TourContext);
  const {
    isEligibleForThankYouPageReminder,
    fetchThankYouPage,
    logError: logThankYouPageFetchError
  } = useAiLpThankYouPageReminder();
  const dispatch = useDispatch();
  const isLandingPage = useSelector(getIsLandingPage);
  const notStarterCustomerish = useSelector(getIsAdvancedPageTemplateOrHasAdvancedFeaturesAccess);
  const dynamicPagesSource = useSelector(getDynamicPageSourceType);
  const dynamicPagesSourceValue = useSelector(getContentModelDynamicPageSourceValue);
  const {
    isContentCrmObjectPublished
  } = useContentCrmObject();
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const absoluteUrl = useSelector(getAbsoluteUrl);
  const publishedOrStagingUrl = useSelector(getPublishedOrStagingUrl);
  const shouldOpenPostPublishCustomDomainSetupModal = useSelector(getShouldOpenPostPublishCustomDomainSetupModal);
  const isEligibleForPostPublishCustomerAgentModal = useShouldDisplayPostPublishCustomerAgentModal();
  const isEligibleForPostPublishContentRemixModal = useSelector(getShouldOpenPostPublishContentRemixModal);
  const themePath = useSelector(getThemePath);
  const domainIsConnected = useSelector(getActiveDomainIsConnected);
  const domainIsInternal = useSelector(getActiveDomainIsInternal);
  const isDndPage = useSelector(getHasAnyLayoutSections);
  const categoryId = useSelector(getCategoryId);
  const appState = useSelector(state => state);
  const contentId = useSelector(getContentModelId);
  const isPersonalizedVariant = useSelector(getIsPersonalizedVariant);
  const hasPersonalizationAccess = useSelector(getHasPersonalizationAccess);
  const hasStagingDomain = useSelector(getHasStagingDomain);
  const isStagingV2 = useSelector(getIsStagingV2);
  const stagedPageDomainName = useSelector(getStagedPageDomainName);
  const personalizedPageUrl = usePersonalizedPageUrl({
    contentId
  });

  // URL needs be conditionalized because the raw slug already includes the language code in BLPs
  // This same logic is used in PagePublishConfirmModalBody and PageURLFieldContainer
  const urlToDisplayInSuccessAlert = useMemo(() => {
    if (isBlogListingPage) {
      return absoluteUrl;
    }
    if (isPersonalizedVariant && hasPersonalizationAccess) {
      return personalizedPageUrl || publishedOrStagingUrl;
    }
    return publishedOrStagingUrl;
  }, [isBlogListingPage, absoluteUrl, publishedOrStagingUrl, personalizedPageUrl, isPersonalizedVariant, hasPersonalizationAccess]);
  const endTourIfAny = () => {
    if (isFromPaymentsGuide()) {
      /**
       * For Payments Activation tours.
       * See https://product.hubteam.com/docs/commerce-pay-activation-fe-handbook/docs/userGuideOnboarding/post031.html
       *
       * This will make the tour sucess modal show up once websites are published.
       */
      const onboardingToursTask = getOnboardingToursTask();
      if (onboardingToursTask) {
        setShowUseCaseTourCompleteModal(true);
        markActionComplete(onboardingToursTask, {
          showTaskCompletionModal: false
        }).catch(error => Raven.captureException(error));
      }
    } else if (tour && tour.getStep() === 'publish') {
      tour.finish();
    }
  };
  const refetchContent = () => {
    const params = {
      baseUrl: PAGES_API_BASE_URL
    };
    dispatch(fetchContent(params));
    dispatch(fetchHardSavedContent(params));
  };
  const triggerPostPublishModals = useCallback(publishType => {
    if (publishType === PublishTypes.publish) {
      const searchParams = new URLSearchParams(window.location.search);
      const viaParam = searchParams.get('via');
      if (viaParam === 'growth-crm-setup') {
        setShowNextActionModal(true);
        return;
      }
      if (shouldOpenPostPublishCustomDomainSetupModal) {
        dispatch(togglePostPublishDomainSetupModal(true));
        return;
      }
      if (isEligibleForPostPublishCustomerAgentModal) {
        dispatch(openModal(MODAL_TYPES.CUSTOMER_AGENT_POST_PUBLISH));
        return;
      }
      if (isEligibleForPostPublishContentRemixModal) {
        dispatch(openModal(MODAL_TYPES.CONTENT_REMIX_POST_PUBLISH));
        return;
      }
    }
    if (!isFromPaymentsGuide()) {
      // Do not display UI Alert banner if in payments guided tour since we will display a modal instead
      const isStagingPublish = hasStagingDomain || isStagingV2;
      const contentType = isStagingPublish ? 'stagingPage' : 'page';

      // For staging v2, the getPublishedOrStagingUrl selector only returns the
      // sandbox URL once the staged page status is 'PROOF'. Right after proofing,
      // onPublishSuccess fires before the staged page query refetches, so the
      // status in Redux is still stale ('DRAFT') and the selector returns the
      // live URL. Compute the sandbox URL directly from the staged page domain
      // (which is not stale) to show the correct URL in the success alert.
      const publishedContentUrl = isStagingV2 && stagedPageDomainName ? buildSandboxUrl(stagedPageDomainName, absoluteUrl) : urlToDisplayInSuccessAlert;
      displayPublishSuccessAlert({
        contentType,
        publishType,
        publishedContentUrl
      });
    }
  }, [shouldOpenPostPublishCustomDomainSetupModal, isEligibleForPostPublishCustomerAgentModal, isEligibleForPostPublishContentRemixModal, dispatch, urlToDisplayInSuccessAlert, setShowNextActionModal, hasStagingDomain, isStagingV2, stagedPageDomainName, absoluteUrl]);
  const onPublishSuccess = (publishType, extraPublishData) => {
    markActionComplete('explore-publish-site');
    if (isLandingPage) {
      markActionComplete('publish-landing-page');
      markActionComplete('create-landing-page');
    }
    if (isInsideMarketingStudio && handleAppOnPublish) {
      const isSchedule = publishType === PublishTypes.schedule;

      // We show a consistent publish success modal for all types in studio
      handleAppOnPublish({
        isUnpublish: false,
        isSchedule,
        willRedirect: false,
        publishDate: isSchedule ? extraPublishData === null || extraPublishData === void 0 ? void 0 : extraPublishData.schedulePublishDate : extraPublishData === null || extraPublishData === void 0 ? void 0 : extraPublishData.publishDate
      });
      return;
    }
    if (isEligibleForThankYouPageReminder) {
      fetchThankYouPage({
        onCompleted: ({
          fetchPageById: {
            isDraft
          }
        }) => {
          if (isDraft) {
            dispatch(openModal(MODAL_TYPES.AILP_THANK_YOU_PAGE_REMINDER));
          } else {
            triggerPostPublishModals(publishType);
          }
        },
        onError: e => {
          logThankYouPageFetchError(e);
          triggerPostPublishModals(publishType);
        }
      });
    } else {
      triggerPostPublishModals(publishType);
    }
    showPagesCsatSurvey(notStarterCustomerish, publishType);
    refetchContent();
  };
  const onUnpublishSuccess = () => {
    if (isInsideMarketingStudio && handleAppOnPublish) {
      handleAppOnPublish({
        isUnpublish: true,
        isSchedule: false,
        willRedirect: false
      });
      return;
    }
    refetchContent();
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.message"
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.text"
      }),
      type: 'success'
    });
  };
  const trackPublishEvent = (isSuccessful, publishType, scheduleType) => {
    trackPublish({
      contentId,
      isConnectedAndCustomDomain: domainIsConnected && !domainIsInternal,
      isDndPage,
      publishType,
      scheduleType,
      usageTrackingProperties: {
        dynamicPagesSource,
        dynamicPagesSourceValue,
        isSchedulingUpdate: isContentCrmObjectPublished && publishType === PublishTypes.schedule,
        themePath
      },
      isSuccessful
    });
  };
  const onPublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  const onUnpublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  return {
    saveAction,
    endTourIfAny,
    onPublishSuccess,
    onPublishError,
    onUnpublishSuccess,
    onUnpublishError,
    trackPublishEvent
  };
};
export default usePublishLifecycleHandlers;